"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.dataSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../../common");
const lingo2_models_1 = require("lingo2-models");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'moderation/resolve';
exports.method = common_1.HttpMethod.POST;
// #region Request
// Тело запроса. Optional
exports.BodySchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  reason: zod_1.z.string().nullable(),
  resolution: zod_1.z.nativeEnum(lingo2_models_1.ModerationStatusEnum),
  status: zod_1.z.nativeEnum(lingo2_models_1.ModerationQueueStatusEnum)
});
function parseBody(values) {
  return exports.BodySchema.parse(values);
}
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.dataSchema = common_1.PanelModerationQueueSchema.partial();
exports.ResponseSchema = common_1.ApiResponse.infer(exports.dataSchema);
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
